import { PropsWithChildren, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BaseModal } from 'components/organisms/modals/base-modal'

interface Props {
	open: boolean
	setOpen?: (...args: any) => any
	onSuccess?: (emailAddress: string) => void
}

export function ActivatePieModal({ open, setOpen }: PropsWithChildren<Props>) {
	const navigate = useNavigate()

	return (
		<BaseModal
			open={open}
			setOpen={setOpen}
			hideHeader
			hideCloseButton
			size="sm"
			customSize="sm:max-w-[320px]"
			className="!p-0 !bg-white !rounded-2xl"
			backdropClassName="!bg-black/60"
		>
			<div className="relative">
				<div className="absolute top-4 right-4 z-[1]">
					<button
						onClick={() => setOpen?.(false)}
						className="flex justify-center items-center focus:outline-none"
					>
						<svg
							className="w-6 h-6 text-primary-tile"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</button>
				</div>
				<div className="modal-header relative rounded-t-2xl overflow-hidden">
					<img className="w-full" src="/images/common/pie-hub/bg-join-modal.jpg" alt="" />
				</div>
				<div className="relative">
					<div className="-mt-20 pb-9 max-w-[300px] mx-auto">
						<h3 className="text-primary-panel font-bold text-2xl text-center">
							Congrats! You were awarded a Pie!
						</h3>
						<div className="text-sm leading-[18px] text-black-50 text-center mt-3 px-8">
							You've met the requirements to skip the waiting list wist.
						</div>
						<div className="text-m text-primary text-center font-bold mt-3 px-8">
							Please connect your paypal account so that you may collect earnings
						</div>
					</div>
					<div className="text-left pt-2 px-6 pb-8">
						<div className="text-center">
							<button
								className="px-6 rounded-3xl transition-all duration-300 bg-primary h-12 hover:bg-primary-hover disabled:backdrop-blur-lg font-bold w-full"
								type="button"
								onClick={() => {
									navigate('/legacy/pie-hub')
									setOpen?.(false)
								}}
							>
								Activate
							</button>
						</div>
					</div>
				</div>
			</div>
		</BaseModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export type ActivatePieModalManagedProps = Record<string, unknown>

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'activate-pie': ActivatePieModalManagedProps
	}
}

export function ManagedActivatePieModal({
	onClose,
}: ActivatePieModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<ActivatePieModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
		/>
	)
}
